import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';

// import LOGO2 from './assets/images/logo2.png';
import LOGO2 from './assets/images/app-logo.png';
import LOGON from './assets/images/logo-n.png';
// import LOGO3 from './assets/images/logo-big-height.png';
import LOGO3 from './assets/images/logo4.png';
import SectionImage from './assets/images/iphone.png';
// import iphoneVideo from './assets/videos/iphoneVideo.mp4';
import { Link } from 'react-router-dom';
import TestimonialsCarousel from './TestimonialsCarousel';
import { Button } from '@mui/material';
import ReactGA from 'react-ga4';
import PricingSection from './PricingSection';
import IPhoneComponent from './components/ui/IPhoneComponent';
import DummyPosterJudgementCard from './components/judge-view/DummyPosterJudgementCard';

// console.log(iphoneVideo);

const LandingPageScreen = () => {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [isRequestLoading, setIsRequestLoading] = useState(false);

  const logGAEvent = () => {
    console.log('Someone landed on landing page');
    ReactGA.event({
      category: 'Landing page category',
      action: 'Landing page viewed',
      label: 'Landing page label',
    });
  };

  useEffect(() => {
    logGAEvent();
  }, []);

  const validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };
  const sendEmail = async () => {
    console.log('Email:', email);
    // check if email is valid
    setIsRequestLoading(true);

    if (!validateEmail(email)) {
      setEmailError('Invalid email. Please enter a valid email address.');
      console.log('Invalid email');
      toast.error('Invalid email. Please enter a valid email address.');
      return;
    } else {
      setEmailError('');
    }
    try {
      await axios.post('/api/contacts', { email });
      toast.success('Thank you for your interest. We will get back to you soon.');
      setEmail('');
    } catch (error) {
      console.error('Error:', error);
      toast.error('Failed to send email');
    }
    setIsRequestLoading(false);
  };

  const submitHandler = (e) => {
    e.preventDefault();
    sendEmail();
  };

  return (
    <div style={{ width: '100%' }}>
      <header className='fixed w-full z-50'>
        <nav className='bg-white border-gray-200 py-2' style={{ boxShadow: '0px 5px 10px #87B52D40' }}>
          <div className='flex flex-wrap items-center justify-between max-w-screen-xl px-4 mx-auto'>
            <a href='#' className='flex items-center'>
              <img src={LOGON} className='h-16 mr-3 sm:h-16 ' alt='InstaJudge Logo' />
            </a>
            <div className='flex items-center lg:order-2'>
              {/* <a
                href='#'
                className='text-gray-800  hover:bg-white-50 focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 sm:mr-2'
              >
                Log in
              </a> */}
              <Link to={'/demo'}>
                <Button
                  variant='contained'
                  color='secondary'
                  className='focus:animate-none hover:animate-none font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 sm:mr-2 lg:mr-0 '
                >
                  Start Demo
                </Button>
              </Link>
            </div>
            <div className='items-center justify-between hidden w-full lg:flex lg:w-auto lg:order-1' id='mobile-menu-2'>
              <ul className='flex flex-col mt-4 font-medium lg:flex-row lg:space-x-8 lg:mt-0'>
                {/* <li>
                  <a
                    href='#hero'
                    className='cursor-pointer block py-2 pl-3 pr-4 text-gray-700 border-b border-gray-100 hover:bg-white-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-mint-light-green lg:p-0  '
                  >
                    Home
                  </a>
                </li> */}
                <li>
                  <a
                    href='#features'
                    className='cursor-pointer block py-2 pl-3 pr-4 text-gray-700 border-b border-gray-100 hover:bg-white-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-mint-light-green lg:p-0  '
                  >
                    Features
                  </a>
                </li>
                <li>
                  <a
                    href='#pricing'
                    className='cursor-pointer block py-2 pl-3 pr-4 text-gray-700 border-b border-gray-100 hover:bg-white-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-mint-light-green lg:p-0  '
                  >
                    Pricing
                  </a>
                </li>
                {/* <li>
                  <a
                    href='#contact-us'
                    className='cursor-pointer block py-2 pl-3 pr-4 text-gray-700 border-b border-gray-100 hover:bg-white-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-mint-light-green lg:p-0  '
                  >
                    Contact us
                  </a>
                </li> */}

                <li>
                  <Link
                    to={'/customer-stories'}
                    className='cursor-pointer block py-2 pl-3 pr-4 text-gray-700 border-b border-gray-100 hover:bg-white-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-mint-light-green lg:p-0  '
                  >
                    Stories
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>

      <section id='hero' className='bg-mint-deep-green hero-section'>
        <div className='max-w-screen-xl px-4 pt-20 pb-8 mx-auto lg:py-16 lg:grid-cols-12 lg:pt-28 flex flex-col-reverse lg:flex-row'>
          <div className='lg:mr-auto place-self-center lg:col-span-7 text-center lg:text-left hero-section-glass-container'>
            <h1 className='max-w-xl mb-4 text-2xl font-bold leading-none tracking-tight md:text-3xl xl:text-4xl text-[#707070]'>Rate </h1>
            <h2 className='max-w-xl mb-4 text-1xl font-extrabold leading-none tracking-tight text-xl md:text-2xl xl:text-3xl'>
              <span className='text-mint-light-green'>Anything, </span>
              <span className='text-mint-deep-green'>Anytime, </span>
              <span className='text-[#000000]'>Anywhere</span>
            </h2>
            <p className='max-w-xl mb-2 font-semibold  lg:mb-4 text-md md:text-lg lg:text-lg text-[#707070]'>
              Whether you're rating scientific presentations, photos, or cupcakes, <span className='text-[#828274] font-semibold'>Insta</span>
              <span className='text-[#98d829] font-semibold'>Judge</span> makes it easy to share your opinion.
            </p>

            <div className='w-full  flex md:flex-row justify-between md:items-baseline flex-col items-center'>
              <p className='max-w-xl mb-2 font-semibold  lg:mb-4 text-md md:text-lg lg:text-lg text-[#707070]'>
                Try for free, no registration required.
              </p>
              <Link to={'/demo'}>
                <Button
                  variant='contained'
                  color='secondary'
                  className='focus:animate-none hover:animate-none font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 sm:mr-2 lg:mr-0 '
                >
                  Start Demo
                </Button>
              </Link>
            </div>
          </div>
          <div className='flex lg:mt-0 lg:col-span-5 lg:flex justify-center items-center py-2'>
            {/* <img src={LOGO3} className='animate-logo' alt='hero image' /> */}
            <IPhoneComponent />
          </div>
        </div>
      </section>

      <section className='bg-white-50' id='features'>
        <div className='max-w-screen-xl px-4 py-8 mx-auto space-y-12 lg:space-y-20 lg:py-24 lg:px-6 '>
          <div className='items-center gap-8 lg:grid lg:grid-cols-2 xl:gap-16'>
            <div className='text-gray-500 sm:text-lg text-center md:text-left'>
              <div className='flex gap-2 justify-center md:justify-start'>
                <h2 className='mb-4 text-3xl font-extrabold tracking-tight text-[#000000]'>Scan,</h2>
                <h2 className='mb-4 text-3xl font-extrabold tracking-tight text-mint-deep-green'>Score,</h2>
                <h2 className='mb-4 text-3xl font-extrabold tracking-tight text-[#98d829]'>Done</h2>
              </div>
              <p className='  lg:text-xl text-[#707070]'>
                The concept is simple; users scan a QR code with their phones and start submitting scores. The results then become instantly available
                for organizers to use and determine winners.
                <p className='mt-4'>
                  It’s a web-based alternative to paper ballots that makes submitting scores effortless and provides instant results.
                </p>
              </p>

              <div className='flex justify-center md:justify-start'>
                <ul role='list' className=' pt-8 space-y-5 border-t border-gray-200 my-7'>
                  <li className='flex space-x-3'>
                    <svg
                      className='flex-shrink-0 w-5 h-5 text-mint-deep-green '
                      fill='currentColor'
                      viewBox='0 0 20 20'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        fillRule='evenodd'
                        d='M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
                        clipRule='evenodd'
                      ></path>
                    </svg>
                    <span className='text-base font-medium leading-tight text-gray-900 '>Instant QR Code Integration</span>
                  </li>
                  <li className='flex space-x-3'>
                    <svg
                      className='flex-shrink-0 w-5 h-5 text-mint-deep-green '
                      fill='currentColor'
                      viewBox='0 0 20 20'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        fillRule='evenodd'
                        d='M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
                        clipRule='evenodd'
                      ></path>
                    </svg>
                    <span className='text-base font-medium leading-tight text-gray-900 '>User-Friendly Rating Interface</span>
                  </li>
                  <li className='flex space-x-3'>
                    <svg
                      className='flex-shrink-0 w-5 h-5 text-mint-deep-green '
                      fill='currentColor'
                      viewBox='0 0 20 20'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        fillRule='evenodd'
                        d='M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
                        clipRule='evenodd'
                      ></path>
                    </svg>
                    <span className='text-base font-medium leading-tight text-gray-900 '>Real-Time Feedback Analysis</span>
                  </li>
                </ul>
              </div>
              <p className='mb-8 text-[#707070] lg:text-xl'>
                Transform ordinary moments into interactive experiences. Simplify feedback collection and ensure every vote is heard and valued,
                making your events unforgettable.
              </p>
            </div>
            <div className='flex justify-end'>
              <DummyPosterJudgementCard />
              {/* <img
                className='hidden w-3/4 mb-4 rounded-lg lg:mb-0 lg:flex object-cover'
                src={SectionImage}
                alt='section-image'
                style={{ width: '300px' }}
              />
              */}
            </div>
          </div>
        </div>
      </section>

      <TestimonialsCarousel />

      {/* Pricing Section */}
      {/* <section className='bg-mint-deep-green '>
        <div className='max-w-screen-xl px-4 py-8 mx-auto lg:py-24 lg:px-6'>
          <div className='max-w-screen-md mx-auto mb-8 text-center lg:mb-12'>
            <h2 className='mb-4 text-3xl font-extrabold tracking-tight text-gray-900 '>Designed for business teams like yours</h2>
            <p className='mb-5 font-light text-gray-500 sm:text-xl '>
              Here at Landwind we focus on markets where technology, innovation, and capital can unlock long-term value and drive economic growth.
            </p>
          </div>
          <div className='space-y-8 lg:grid lg:grid-cols-3 sm:gap-6 xl:gap-10 lg:space-y-0'>
            <div className='flex flex-col max-w-lg p-6 mx-auto text-center text-gray-900 bg-mint-deep-green border border-gray-100 rounded-lg shadow xl:p-8  '>
              <h3 className='mb-4 text-2xl font-semibold'>Starter</h3>
              <p className='font-light text-gray-500 sm:text-lg '>Best option for personal use & for your next project.</p>
              <div className='flex items-baseline justify-center my-8'>
                <span className='mr-2 text-5xl font-extrabold'>$29</span>
                <span className='text-gray-500 '>/month</span>
              </div>

              <ul role='list' className='mb-8 space-y-4 text-left'>
                <li className='flex items-center space-x-3'>
                  <svg className='flex-shrink-0 w-5 h-5 text-green-500' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fillRule='evenodd'
                      d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                      clipRule='evenodd'
                    ></path>
                  </svg>
                  <span>Individual configuration</span>
                </li>
                <li className='flex items-center space-x-3'>
                  <svg className='flex-shrink-0 w-5 h-5 text-green-500' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fillRule='evenodd'
                      d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                      clipRule='evenodd'
                    ></path>
                  </svg>
                  <span>No setup, or hidden fees</span>
                </li>
                <li className='flex items-center space-x-3'>
                  <svg className='flex-shrink-0 w-5 h-5 text-green-500' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fillRule='evenodd'
                      d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                      clipRule='evenodd'
                    ></path>
                  </svg>
                  <span>
                    Team size: <span className='font-semibold'>1 developer</span>
                  </span>
                </li>
                <li className='flex items-center space-x-3'>
                  <svg className='flex-shrink-0 w-5 h-5 text-green-500' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fillRule='evenodd'
                      d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                      clipRule='evenodd'
                    ></path>
                  </svg>
                  <span>
                    Premium support: <span className='font-semibold'>6 months</span>
                  </span>
                </li>
                <li className='flex items-center space-x-3'>
                  <svg className='flex-shrink-0 w-5 h-5 text-green-500' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fillRule='evenodd'
                      d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                      clipRule='evenodd'
                    ></path>
                  </svg>
                  <span>
                    Free updates: <span className='font-semibold'>6 months</span>
                  </span>
                </li>
              </ul>
              <a
                href='#'
                className='text-white bg-sky-600 hover:bg-mint-light-green focus:ring-4 focus:ring-purple-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center   '
              >
                Get started
              </a>
            </div>

            <div className='flex flex-col max-w-lg p-6 mx-auto text-center text-gray-900 bg-mint-deep-green border border-gray-100 rounded-lg shadow  xl:p-8  '>
              <h3 className='mb-4 text-2xl font-semibold'>Company</h3>
              <p className='font-light text-gray-500 sm:text-lg '>Relevant for multiple users, extended & premium support.</p>
              <div className='flex items-baseline justify-center my-8'>
                <span className='mr-2 text-5xl font-extrabold'>$99</span>
                <span className='text-gray-500  '>/month</span>
              </div>

              <ul role='list' className='mb-8 space-y-4 text-left'>
                <li className='flex items-center space-x-3'>
                  <svg className='flex-shrink-0 w-5 h-5 text-green-500' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fillRule='evenodd'
                      d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                      clipRule='evenodd'
                    ></path>
                  </svg>
                  <span>Individual configuration</span>
                </li>
                <li className='flex items-center space-x-3'>
                  <svg className='flex-shrink-0 w-5 h-5 text-green-500' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fillRule='evenodd'
                      d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                      clipRule='evenodd'
                    ></path>
                  </svg>
                  <span>No setup, or hidden fees</span>
                </li>
                <li className='flex items-center space-x-3'>
                  <svg className='flex-shrink-0 w-5 h-5 text-green-500' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fillRule='evenodd'
                      d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                      clipRule='evenodd'
                    ></path>
                  </svg>
                  <span>
                    Team size: <span className='font-semibold'>10 developers</span>
                  </span>
                </li>
                <li className='flex items-center space-x-3'>
                  <svg className='flex-shrink-0 w-5 h-5 text-green-500' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fillRule='evenodd'
                      d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                      clipRule='evenodd'
                    ></path>
                  </svg>
                  <span>
                    Premium support: <span className='font-semibold'>24 months</span>
                  </span>
                </li>
                <li className='flex items-center space-x-3'>
                  <svg className='flex-shrink-0 w-5 h-5 text-green-500' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fillRule='evenodd'
                      d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                      clipRule='evenodd'
                    ></path>
                  </svg>
                  <span>
                    Free updates: <span className='font-semibold'>24 months</span>
                  </span>
                </li>
              </ul>
              <a
                href='#'
                className='text-white bg-sky-600 hover:bg-mint-light-green focus:ring-4 focus:ring-purple-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center   '
              >
                Get started
              </a>
            </div>

            <div className='flex flex-col max-w-lg p-6 mx-auto text-center text-gray-900 bg-mint-deep-green border border-gray-100 rounded-lg shadow  xl:p-8  '>
              <h3 className='mb-4 text-2xl font-semibold'>Enterprise</h3>
              <p className='font-light text-gray-500 sm:text-lg '>Best for large scale uses and extended redistribution rights.</p>
              <div className='flex items-baseline justify-center my-8'>
                <span className='mr-2 text-5xl font-extrabold'>$499</span>
                <span className='text-gray-500 '>/month</span>
              </div>

              <ul role='list' className='mb-8 space-y-4 text-left'>
                <li className='flex items-center space-x-3'>
                  <svg className='flex-shrink-0 w-5 h-5 text-green-500' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fillRule='evenodd'
                      d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                      clipRule='evenodd'
                    ></path>
                  </svg>
                  <span>Individual configuration</span>
                </li>
                <li className='flex items-center space-x-3'>
                  <svg className='flex-shrink-0 w-5 h-5 text-green-500' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fillRule='evenodd'
                      d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                      clipRule='evenodd'
                    ></path>
                  </svg>
                  <span>No setup, or hidden fees</span>
                </li>
                <li className='flex items-center space-x-3'>
                  <svg className='flex-shrink-0 w-5 h-5 text-green-500' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fillRule='evenodd'
                      d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                      clipRule='evenodd'
                    ></path>
                  </svg>
                  <span>
                    Team size: <span className='font-semibold'>100+ developers</span>
                  </span>
                </li>
                <li className='flex items-center space-x-3'>
                  <svg className='flex-shrink-0 w-5 h-5 text-green-500' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fillRule='evenodd'
                      d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                      clipRule='evenodd'
                    ></path>
                  </svg>
                  <span>
                    Premium support: <span className='font-semibold'>36 months</span>
                  </span>
                </li>
                <li className='flex items-center space-x-3'>
                  <svg className='flex-shrink-0 w-5 h-5 text-green-500' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fillRule='evenodd'
                      d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                      clipRule='evenodd'
                    ></path>
                  </svg>
                  <span>
                    Free updates: <span className='font-semibold'>36 months</span>
                  </span>
                </li>
              </ul>
              <a
                href='#'
                className='text-white bg-sky-600 hover:bg-mint-light-green focus:ring-4 focus:ring-purple-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center   '
              >
                Get started
              </a>
            </div>
          </div>
        </div>
      </section> */}

      {/* <section className='bg-mint-deep-green '>
        <div className='max-w-screen-xl px-4 pb-8 mx-auto lg:pb-24 lg:px-6 '>
          <h2 className='mb-6 text-3xl font-extrabold tracking-tight text-center text-gray-900 lg:mb-8 lg:text-3xl '>Frequently asked questions</h2>
          <div className='max-w-screen-md mx-auto'>
            <div
              id='accordion-flush'
              data-accordion='collapse'
              data-active-classes='bg-mint-deep-green  text-gray-900 '
              data-inactive-classes='text-gray-500 '
            >
              <h3 id='accordion-flush-heading-1'>
                <button
                  type='button'
                  className='flex items-center justify-between w-full py-5 font-medium text-left text-gray-900 bg-mint-deep-green border-b border-gray-200   '
                  data-accordion-target='#accordion-flush-body-1'
                  aria-expanded='true'
                  aria-controls='accordion-flush-body-1'
                >
                  <span>Can I use Landwind in open-source projects?</span>
                  <svg
                    data-accordion-icon=''
                    className='w-6 h-6 rotate-180 shrink-0'
                    fill='currentColor'
                    viewBox='0 0 20 20'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      fillRule='evenodd'
                      d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z'
                      clipRule='evenodd'
                    ></path>
                  </svg>
                </button>
              </h3>
              <div id='accordion-flush-body-1' className='' aria-labelledby='accordion-flush-heading-1'>
                <div className='py-5 border-b border-gray-200 '>
                  <p className='mb-2 text-gray-500 '>
                    Landwind is an open-source library of interactive components built on top of Tailwind CSS including buttons, dropdowns, modals,
                    navbars, and more.
                  </p>
                  <p className='text-gray-500 '>
                    Check out this guide to learn how to{' '}
                    <a href='#' className='text-purple-600  hover:underline'>
                      get started
                    </a>{' '}
                    and start developing websites even faster with components on top of Tailwind CSS.
                  </p>
                </div>
              </div>
              <h3 id='accordion-flush-heading-2'>
                <button
                  type='button'
                  className='flex items-center justify-between w-full py-5 font-medium text-left text-gray-500 border-b border-gray-200  '
                  data-accordion-target='#accordion-flush-body-2'
                  aria-expanded='false'
                  aria-controls='accordion-flush-body-2'
                >
                  <span>Is there a Figma file available?</span>
                  <svg data-accordion-icon='' className='w-6 h-6 shrink-0' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fillRule='evenodd'
                      d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z'
                      clipRule='evenodd'
                    ></path>
                  </svg>
                </button>
              </h3>
              <div id='accordion-flush-body-2' className='hidden' aria-labelledby='accordion-flush-heading-2'>
                <div className='py-5 border-b border-gray-200 '>
                  <p className='mb-2 text-gray-500 '>
                    Landwind is first conceptualized and designed using the Figma software so everything you see in the library has a design
                    equivalent in our Figma file.
                  </p>
                  <p className='text-gray-500 '>
                    Check out the{' '}
                    <a href='#' className='text-purple-600  hover:underline'>
                      Figma design system
                    </a>{' '}
                    based on the utility classes from Tailwind CSS and components from Landwind.
                  </p>
                </div>
              </div>
              <h3 id='accordion-flush-heading-3'>
                <button
                  type='button'
                  className='flex items-center justify-between w-full py-5 font-medium text-left text-gray-500 border-b border-gray-200  '
                  data-accordion-target='#accordion-flush-body-3'
                  aria-expanded='false'
                  aria-controls='accordion-flush-body-3'
                >
                  <span>What are the differences between Landwind and Tailwind UI?</span>
                  <svg data-accordion-icon='' className='w-6 h-6 shrink-0' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fillRule='evenodd'
                      d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z'
                      clipRule='evenodd'
                    ></path>
                  </svg>
                </button>
              </h3>
              <div id='accordion-flush-body-3' className='hidden' aria-labelledby='accordion-flush-heading-3'>
                <div className='py-5 border-b border-gray-200 '>
                  <p className='mb-2 text-gray-500 '>
                    The main difference is that the core components from Landwind are open source under the MIT license, whereas Tailwind UI is a paid
                    product. Another difference is that Landwind relies on smaller and standalone components, whereas Tailwind UI offers sections of
                    pages.
                  </p>
                  <p className='mb-2 text-gray-500 '>
                    However, we actually recommend using both Landwind, Landwind Pro, and even Tailwind UI as there is no technical reason stopping
                    you from using the best of two worlds.
                  </p>
                  <p className='mb-2 text-gray-500 '>Learn more about these technologies:</p>
                  <ul className='pl-5 text-gray-500 list-disc '>
                    <li>
                      <a href='#' className='text-purple-600  hover:underline'>
                        Landwind Pro
                      </a>
                    </li>
                    <li>
                      <a href='#' className='text-purple-600  hover:underline'>
                        Tailwind UI
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <h3 id='accordion-flush-heading-4'>
                <button
                  type='button'
                  className='flex items-center justify-between w-full py-5 font-medium text-left text-gray-500 border-b border-gray-200  '
                  data-accordion-target='#accordion-flush-body-4'
                  aria-expanded='false'
                  aria-controls='accordion-flush-body-4'
                >
                  <span>What about browser support?</span>
                  <svg data-accordion-icon='' className='w-6 h-6 shrink-0' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fillRule='evenodd'
                      d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z'
                      clipRule='evenodd'
                    ></path>
                  </svg>
                </button>
              </h3>
              <div id='accordion-flush-body-4' className='hidden' aria-labelledby='accordion-flush-heading-4'>
                <div className='py-5 border-b border-gray-200 '>
                  <p className='mb-2 text-gray-500 '>
                    The main difference is that the core components from Landwind are open source under the MIT license, whereas Tailwind UI is a paid
                    product. Another difference is that Landwind relies on smaller and standalone components, whereas Tailwind UI offers sections of
                    pages.
                  </p>
                  <p className='mb-2 text-gray-500 '>
                    However, we actually recommend using both Landwind, Landwind Pro, and even Tailwind UI as there is no technical reason stopping
                    you from using the best of two worlds.
                  </p>
                  <p className='mb-2 text-gray-500 '>Learn more about these technologies:</p>
                  <ul className='pl-5 text-gray-500 list-disc '>
                    <li>
                      <a href='#' className='text-purple-600  hover:underline'>
                        Landwind Pro
                      </a>
                    </li>
                    <li>
                      <a href='#' className='text-purple-600  hover:underline'>
                        Tailwind UI
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className='bg-white-50 ' id='pricing'>
        <PricingSection />
      </section>
      {/* <section className='bg-white-50 ' id='contact-us'>
        <div className='max-w-screen-xl px-4 py-8 mx-auto lg:py-16 lg:px-6'>
          <div className='max-w-screen-sm mx-auto text-center'>
            <h2 className='mb-4 text-3xl font-extrabold leading-tight tracking-tight text-gray-900 '>Contact us to get started</h2>
            <p className='mb-6 font-light text-gray-500  md:text-lg'>Provide an email and we will get back to you as soon as possible.</p>
            <form className='flex flex-col md:items-baseline justify-center space-y-4 md:flex-row sm:space-x-4 sm:space-y-0' onSubmit={submitHandler}>
              <input
                type='email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder='Enter your email'
                className='px-4 py-3 mb-4 text-gray-900 bg-white border border-gray-200 rounded-lg focus:ring-4 focus:ring-purple-200 focus:outline-none '
              />
              <Button
                disabled={isRequestLoading}
                type='submit'
                // className=' text-white bg-mint-light-green hover:bg-mint-light-green focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2  focus:outline-none '
                variant='contained'
                color='secondary'
              >
                Contact us
              </Button>
            </form>
          </div>
        </div>
      </section> */}
      {/* <footer className='bg-mint-light-green'> */}
      <footer className='bg-mint-light-green'>
        <div className='max-w-screen-xl p-4 py-6 mx-auto lg:py-16 md:p-8 lg:p-10'>
          {/* <div className='grid grid-cols-2 gap-8 md:grid-cols-3 lg:grid-cols-5'>
            <div>
              <h3 className='mb-6 text-sm font-semibold text-gray-900 uppercase '>Company</h3>
              <ul className='text-gray-500 '>
                <li className='mb-4'>
                  <a href='#' className=' hover:underline'>
                    About
                  </a>
                </li>
                <li className='mb-4'>
                  <a href='#' className='hover:underline'>
                    Careers
                  </a>
                </li>
                <li className='mb-4'>
                  <a href='#' className='hover:underline'>
                    Brand Center
                  </a>
                </li>
                <li className='mb-4'>
                  <a href='#' className='hover:underline'>
                    Blog
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className='mb-6 text-sm font-semibold text-gray-900 uppercase '>Help center</h3>
              <ul className='text-gray-500 '>
                <li className='mb-4'>
                  <a href='#' className='hover:underline'>
                    Discord Server
                  </a>
                </li>
                <li className='mb-4'>
                  <a href='#' className='hover:underline'>
                    Twitter
                  </a>
                </li>
                <li className='mb-4'>
                  <a href='#' className='hover:underline'>
                    Facebook Group
                  </a>
                </li>
                <li className='mb-4'>
                  <a href='#' className='hover:underline'>
                    Contact Us
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className='mb-6 text-sm font-semibold text-gray-900 uppercase '>Legal</h3>
              <ul className='text-gray-500 '>
                <li className='mb-4'>
                  <a href='#' className='hover:underline'>
                    Privacy Policy
                  </a>
                </li>
                <li className='mb-4'>
                  <a href='#' className='hover:underline'>
                    Licensing
                  </a>
                </li>
                <li className='mb-4'>
                  <a href='#' className='hover:underline'>
                    Terms
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className='mb-6 text-sm font-semibold text-gray-900 uppercase '>Company</h3>
              <ul className='text-gray-500 '>
                <li className='mb-4'>
                  <a href='#' className=' hover:underline'>
                    About
                  </a>
                </li>
                <li className='mb-4'>
                  <a href='#' className='hover:underline'>
                    Careers
                  </a>
                </li>
                <li className='mb-4'>
                  <a href='#' className='hover:underline'>
                    Brand Center
                  </a>
                </li>
                <li className='mb-4'>
                  <a href='#' className='hover:underline'>
                    Blog
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className='mb-6 text-sm font-semibold text-gray-900 uppercase '>Download</h3>
              <ul className='text-gray-500 '>
                <li className='mb-4'>
                  <a href='#' className='hover:underline'>
                    iOS
                  </a>
                </li>
                <li className='mb-4'>
                  <a href='#' className='hover:underline'>
                    Android
                  </a>
                </li>
                <li className='mb-4'>
                  <a href='#' className='hover:underline'>
                    Windows
                  </a>
                </li>
                <li className='mb-4'>
                  <a href='#' className='hover:underline'>
                    MacOS
                  </a>
                </li>
              </ul>
            </div>
          </div> */}
          {/* <hr className='my-6 border-gray-200 sm:mx-auto  lg:my-8' /> */}
          <div className='text-center'>
            {/* <a href='#' className='flex items-center justify-center mb-5 text-2xl font-semibold text-gray-900 '>
              <img src='./images/logo.svg' className='h-6 mr-3 sm:h-9' alt='Landwind Logo' />
              InstaJudge
            </a> */}
            <span className='block text-sm font-semibold text-center text-mint-deep-green '>© 2024 InstaJudge™. All Rights Reserved.</span>
            <ul className='flex justify-center mt-5 space-x-5'>
              <li>
                <a target='_blank' href='https://www.tiktok.com/@instajudge' className='text-mint-deep-green hover:text-gray-900  '>
                  <span class='[&>svg]:h-5 [&>svg]:w-5'>
                    <svg xmlns='http://www.w3.org/2000/svg' fill='currentColor' viewBox='0 0 448 512'>
                      <path d='M448 209.9a210.1 210.1 0 0 1 -122.8-39.3V349.4A162.6 162.6 0 1 1 185 188.3V278.2a74.6 74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2h0A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z' />
                    </svg>
                  </span>
                </a>
              </li>
              <li>
                <a target='_blank' href='https://www.instagram.com/instajudge1.0/' className='text-mint-deep-green hover:text-gray-900  '>
                  <span class='[&>svg]:h-5 [&>svg]:w-5'>
                    <svg xmlns='http://www.w3.org/2000/svg' fill='currentColor' viewBox='0 0 448 512'>
                      <path d='M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z' />
                    </svg>
                  </span>
                </a>
              </li>
              <li>
                <a target='_blank' href='https://x.com/InstaJudge_' className='text-mint-deep-green hover:text-gray-900  '>
                  <span class='[&>svg]:h-5 [&>svg]:w-5'>
                    <svg xmlns='http://www.w3.org/2000/svg' fill='currentColor' viewBox='0 0 512 512'>
                      <path d='M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z' />
                    </svg>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPageScreen;
